<template>
  <section class="bucontact">
    <div class="bucontact-info py-5">
      <div class="container">
        <div class="row">
          <div class="bucontact-info__text col-12 col-md-6 col-lg-4">
            <article>
              <header class="mb-2">
                <h1 class="text-uppercase mb-1">{{ item.text }}</h1>
                <span class="sub-title font-patrick-hand text-uppercase d-block">Neem contact op met {{ surrounding.name }}</span>
              </header>
              <p v-html="item.itemable.text"></p>
            </article>
          </div>
          <div class="bucontact-info__address col-12 col-md-6 col-lg-4">
            <span class="sub-title font-patrick-hand text-uppercase d-block">Contactgegevens</span>
            <ul>
              <li>
                <i class="d-inline-block fa fa-map-marker"></i> {{ surrounding.address.street }} {{ surrounding.address.housenumber }}
              </li>
              <li>
                <i class="d-inline-block"></i> {{ surrounding.address.postalcode }} {{ surrounding.address.city }}
              </li>
              <li v-if="surrounding.phonenumber">
                <i class="d-inline-block fa fa-phone"></i> <a :href="'tel:' + surrounding.phonenumber.replace(' ', '').replace('-', '')" class="text-decoration-none">{{ surrounding.phonenumber }}</a>
              </li>
              <li v-if="surrounding.email">
                <i class="d-inline-block fa fa-envelope"></i> <a :href="'mailto:' + surrounding.email" class="text-decoration-none">{{ surrounding.email }}</a>
              </li>
            </ul>
          </div>
          <div class="bucontact-info__image d-none d-lg-block col-lg-4 align-self-stretch">
            <div
              :style="{ backgroundImage: 'url(' + item.graphic.data.graphic + ')' }"
              class="img-container w-100 h-100"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bucontact-form position-relative py-5">
      <div
        :style="{ backgroundColor: surrounding.style }"
        class="bucontact-form__overlay position-absolute"
      />
      <div class="container">
        <div class="row">
          <ec-business-contact-form
            class="col-12"
            :email="surrounding.email"
            :title="'Meer informatie? Of vraag vrijblijvend een offerte aan!'"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ecBusinessContactForm from './General/Element/Form/Contact'

export default {
  name: 'ec-business-contact',
  components: {
    ecBusinessContactForm
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      title: 'Dit is het ec-business-contact component.'
    }
  }
}
</script>

<style scoped>

</style>
